module.exports = __webpack_public_path__ + "media/images/news/icon-left-12779818d6015545fe82cbffb04b83fe.svg";